<script setup lang="ts">
import { AppMarkdownWrapper, AppStandardModal } from '@libs/ui';
import type { DestinationInformation } from '@libs/trip-planner-interfaces';

import DestinationInformationSectionMarkdownStyles from '../DestinationInformationSectionMarkdownStyles.vue';

interface FullDestinationDescriptionModalProps {
  destinationInformation: DestinationInformation;
}
const props = defineProps<FullDestinationDescriptionModalProps>();

interface FullDestinationDescriptionModalEmits {
  (eventName: 'close'): void;
}
const emit = defineEmits<FullDestinationDescriptionModalEmits>();
</script>

<template>
  <AppStandardModal
    :close-button-aria-label="$t('a11y.close_panel')"
    @close="emit('close')"
  >
    <template #title>
      {{
        $t('planner.about_destination', [
          props.destinationInformation.destination,
        ])
      }}
    </template>
    <template #body>
      <DestinationInformationSectionMarkdownStyles>
        <AppMarkdownWrapper
          :source="props.destinationInformation.description"
        />
      </DestinationInformationSectionMarkdownStyles>
    </template>
  </AppStandardModal>
</template>
